import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { TextArea } from '@repo/design-system/components/ui/text-area';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { DEFAULT_PIN_COLOR } from '@repo/store/maps/utils/mapData';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
interface LocationContentEditingProps {
  description?: string;
  onDescriptionChange?: (description: string) => void;
  onColorChange?: (color: string) => void;
  color?: string;
}
const colorOptions = ['#4BEB6E', '#1FD9C1', DEFAULT_PIN_COLOR, '#0F73FF', '#4F3CE4', '#8610DE', '#DC2D83', '#F88646'] as const;
const colorButtonStyles = css({
  width: '[24px]',
  height: '[24px]',
  borderRadius: 'full',
  cursor: 'pointer',
  transition: 'all',
  _hover: {
    transform: 'scale(1.1)'
  }
});
export const LocationContentEditing: React.FC<LocationContentEditingProps> = t0 => {
  const $ = _c(42);
  const {
    description,
    onDescriptionChange,
    onColorChange,
    color: t1
  } = t0;
  const color = t1 === undefined ? DEFAULT_PIN_COLOR : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["game_map"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useT(t2);
  const [editDescription, setEditDescription] = useState(description || "");
  const getValidColor = _temp;
  let t3;
  if ($[1] !== color) {
    t3 = getValidColor(color);
    $[1] = color;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [editColor, setEditColor] = useState(t3);
  let t4;
  let t5;
  if ($[3] !== color || $[4] !== description || $[5] !== onColorChange) {
    t4 = () => {
      setEditDescription(description || "");
      const validColor = getValidColor(color);
      setEditColor(validColor);
      if (color !== validColor && onColorChange) {
        onColorChange(validColor);
      }
    };
    t5 = [description, color, onColorChange, getValidColor];
    $[3] = color;
    $[4] = description;
    $[5] = onColorChange;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== onDescriptionChange) {
    t6 = value => {
      setEditDescription(value);
      onDescriptionChange?.(value);
    };
    $[8] = onDescriptionChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleDescriptionChange = t6;
  let t7;
  if ($[10] !== onColorChange) {
    t7 = newColor => {
      setEditColor(newColor);
      onColorChange?.(newColor);
    };
    $[10] = onColorChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleColorChange = t7;
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp2);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <Type variant="caption" color="white">{t8}</Type>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleDescriptionChange) {
    t10 = e => handleDescriptionChange(e.target.value);
    $[16] = handleDescriptionChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t(_temp3);
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== editDescription || $[21] !== t10 || $[22] !== t11) {
    t12 = <TextArea value={editDescription} onChange={t10} placeholder={t11} rows={3} fullWidth={true} maxLength={2000} />;
    $[20] = editDescription;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <FlexColumn gap="8" width="full">{t9}{t12}</FlexColumn>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t(_temp4);
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <Type variant="caption" color="white">{t14}</Type>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== editColor || $[32] !== handleColorChange) {
    t16 = colorOptions.map(colorOption => <button key={colorOption} className={colorButtonStyles} style={{
      backgroundColor: colorOption,
      border: editColor === colorOption ? "3px solid white" : "2px solid transparent",
      boxShadow: editColor === colorOption ? "0 10px 15px -3px rgba(0, 0, 0, 0.1)" : "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
    }} onClick={() => handleColorChange(colorOption)} type="button" aria-label={`Select color ${colorOption}`} />);
    $[31] = editColor;
    $[32] = handleColorChange;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <FlexRow gap="8" wrap="wrap">{t16}</FlexRow>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t17) {
    t18 = <FlexColumn gap="8">{t15}{t17}</FlexColumn>;
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t13 || $[40] !== t18) {
    t19 = <FlexColumn gap="12" width="full">{t13}{t18}</FlexColumn>;
    $[39] = t13;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
function _temp(inputColor) {
  return inputColor && colorOptions.includes(inputColor as (typeof colorOptions)[number]) ? inputColor : DEFAULT_PIN_COLOR;
}
function _temp2($) {
  return $.description;
}
function _temp3($_0) {
  return $_0.custom_marker_description;
}
function _temp4($_1) {
  return $_1.color;
}